import { netJsonp, netOldJsonp, netPost,netJson,netNormalPost,netNormalJsonPost} from "./baseNet.js";
import ip from "../config/url.js";

const api = {
    // 登录
    loginToken(param,success,fail){
        netJsonp(ip.ucWeb+'/jsonhttp/user_login.htm',param,success, fail);
    },
    //短信登录
    smsLogin(param,success,fail){
        netJsonp(ip.ucWeb+'/jsonhttp/sms_login.htm',param,success, fail);
    },
    //注册
    getregister(param,success,fail){
        netJsonp(ip.ucWeb+'/jsonhttp/user_reg.htm', param,success, fail);
    },
    //获取验证码
    getAuth(param,success,fail){
        netJsonp(ip.ucWeb+'/jsonhttp/send_reg_checkcode.htm', param,success, fail);
    },
    //手机登录验证码
    loginAuth(param,success,fail){
        netJsonp(ip.ucWeb+'/jsonhttp/send_mobile_active_for_ajax.htm', param,success, fail);
    },
    //绑定手机修改获取验证码
    getMobileBindAuth(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/user/send_user_chk_code.htm', param,success, fail);
    },
    //绑定手机修改获取验证码
    userSignIn(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/signin/user_sign_in.htm', param,success, fail);
    },
    //绑定手机修改获取验证码
    userSignIn(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/signin/user_sign_in.htm', param,success, fail);
    },
    //获取产品树
    getProductTree(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/agency/get_product_tree.htm',param,success, fail);
    },
    getContractFullPath(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/contract/get_contract_full_path.htm',param,success, fail);
    },
    //客户信息
    getCustomerUserInfo(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/agency/get_customer_user_info.htm',param,success, fail);
    },
    //我的客户
    customerPaginal(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/agency/query_customer_paginal.htm',param,success, fail);
    },
    //获取产品map接口
    getProductInfoMap(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/biz/get_product_info_map.htm',param,success, fail);
    },
    //代理商编辑客户
     editAgencyCustomer(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/agency/edit_agency_customer.htm',param,success, fail);
    },
    //签到
    getSignApplyList(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/sign/query_sign_apply_paginal.htm',param,success, fail);
    },
    //是否签到
    showSignInStatus(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/signin/show_sign_in_status.htm',param,success, fail);
    },
    //通过签约获取合同
    getContractListBySignId(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/sign/select_contract_list_by_sign_id.htm',param,success, fail);
    },
    //获取合同详情接口
    getSignApplyInfoById(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/sign/select_biz_sign_apply_by_id.htm',param,success, fail);
    },
    //确认合同接口
    confirmSignApplyInfo(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/sign/confirm_sign_apply_info.htm',param,success, fail);
    },
    //申请合作列表
    getApplyList(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/partner/cooperation_apply_list.htm',param,success, fail);
    },
    //代理商合作列表
    agencyBusinessOpportunityPaginal(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/agency/query_agency_business_opportunity_paginal.htm',param,success, fail);
    },
    //获取积分列表
    getPointList(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/points/query_user_points_detail_pagination.htm',param,success, fail);
    },
    //获取积分详情
    getPointInfo(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/points/show_sign_in_status.htm',param,success, fail);
    },
    //获取申请详情接口
    getProductInfoMap(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/biz/get_product_info_map.htm',param,success, fail);
    },
    //登出接口
    mobileLogout(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/suc_logout.htm',param,success, fail);
    },
    getPartnerDetail(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/partner/partner_detail.htm',param,success, fail);
    },

    applyInnerUser(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/partner/apply_inner_user.htm',param,success, fail);
    },

    validMobileOld(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/user/valid_mobile_old.htm',param,success, fail);
    },
    validMobileNew(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/user/valid_mobile_new.htm',param,success, fail);
    },

    changePwd(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/user/change_pwd.htm',param,success, fail);
    }, 
    getConfirm(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/partner/apply_cooperative_partner.htm',param,success, fail);
    },
    getPromoteCode(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/agency/get_promote_code.htm',param,success, fail);
    },
    addAgencyCustomer(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/agency/add_agency_customer.htm',param,success, fail);
    },
    //签到验证码
    getSignInAuth(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/send_mobile_active_for_sonference_sign_in.htm',param,success, fail);
    },
    //签到
    signIn(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/user_conference_sign_in.htm',param,success, fail);
    },
    //得到当前Ip
    getIp(success,fail){
        netJson("https://httpbin.org/ip",{},success, fail);
    },
    //打赏
    tippingVia(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/points/tipping_via_qr_code.htm',param,success, fail);
    },
    //得到导航栏数据
    getNavBar(param,success,fail){
        netOldJsonp(ip.cms2Url+'/ajax/html5/getNavBar.json',param,success, fail);
    },
    //得到微信签名
    getticket(param,success,fail){
        netNormalPost(ip.weixin+'/v/wechat/getticket.json',param,success, fail);
    },
    //活动
    activity_temp(param,success,fail){
        netPost(ip.ucWeb+'/jsonhttp/activity/activity_temp.htm',param,success, fail);
    },
};

export default api;


// WEBPACK FOOTER //
// ./src/network/netApi.js